import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight, CheckCircle, Copy, Check, MessageSquare, Smartphone, FileText, Search, Clock, Link as LinkIcon, BarChart3, TrendingUp, User, Video, Star, Zap, Share2 } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FeaturesPage() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen w-full bg-background px-4 py-12 md:px-16 lg:px-32 flex flex-col items-center justify-center overflow-x-hidden" data-id="element-254">
      <div className="w-full max-w-4xl mx-auto text-center" data-id="element-255">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-256">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-14 w-auto" data-id="element-257" />
        </div>
        {/* Hero Section */}
        <div className="mb-2" data-id="element-258">
          <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-259">
            New Creator Features
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-slide-down" style={{
        animationDelay: '100ms'
      }} data-id="element-260">
          Unlock Your <span className="text-primary" data-id="element-261">Creator Stats</span>
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 animate-slide-down" style={{
        animationDelay: '200ms'
      }} data-id="element-262">
          Connect your TikTok account to access powerful analytics, track your
          performance, and get insights on your content—all via text message.
        </p>
        {/* Quick Command Reference */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12 animate-scale" style={{
        animationDelay: '300ms'
      }} data-id="element-263">
          <Card className="bg-primary/5 border-primary/20" data-id="element-264">
            <CardContent className="p-4 flex flex-col items-center" data-id="element-265">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center mb-3" data-id="element-266">
                <LinkIcon size={20} className="text-primary" data-id="element-267" />
              </div>
              <p className="font-bold" data-id="element-268">/link @handle</p>
              <p className="text-sm text-muted-foreground" data-id="element-269">
                Connect your TikTok
              </p>
            </CardContent>
          </Card>
          <Card className="bg-primary/5 border-primary/20" data-id="element-270">
            <CardContent className="p-4 flex flex-col items-center" data-id="element-271">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center mb-3" data-id="element-272">
                <BarChart3 size={20} className="text-primary" data-id="element-273" />
              </div>
              <p className="font-bold" data-id="element-274">/stats</p>
              <p className="text-sm text-muted-foreground" data-id="element-275">
                View your dashboard
              </p>
            </CardContent>
          </Card>
          <Card className="bg-primary/5 border-primary/20" data-id="element-276">
            <CardContent className="p-4 flex flex-col items-center" data-id="element-277">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center mb-3" data-id="element-278">
                <Video size={20} className="text-primary" data-id="element-279" />
              </div>
              <p className="font-bold" data-id="element-280">/myvideos</p>
              <p className="text-sm text-muted-foreground" data-id="element-281">
                See your top content
              </p>
            </CardContent>
          </Card>
        </div>
        {/* Example SMS Conversation */}
        <div className="mb-16" data-id="element-282">
          <h2 className="text-2xl font-bold mb-6" data-id="element-283">See It In Action</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-284">
            {/* Left Side - Connect Account */}
            <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left" data-id="element-285">
              <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-286">
                <LinkIcon size={18} className="text-primary mr-2" data-id="element-287" />
                Connect Your Account
              </h3>
              <div className="space-y-4" data-id="element-288">
                <div className="flex justify-end" data-id="element-289">
                  <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-290">
                    /link @switmer777
                  </div>
                </div>
                <div className="flex justify-start" data-id="element-291">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-292">
                    <p className="flex items-start gap-2" data-id="element-293">
                      <span className="text-xl flex-shrink-0" data-id="element-294">🔗</span>
                      <span data-id="element-295">
                        Success! Your TikTok account @switmer777 has been linked
                        to ScribeTok.
                      </span>
                    </p>
                    <p className="mt-2 ml-7" data-id="element-296">
                      You can now use /stats to see your creator dashboard and
                      /myvideos to view your top content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Side - View Stats */}
            <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left" data-id="element-297">
              <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-298">
                <BarChart3 size={18} className="text-primary mr-2" data-id="element-299" />
                View Your Stats
              </h3>
              <div className="space-y-4" data-id="element-300">
                <div className="flex justify-end" data-id="element-301">
                  <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-302">
                    /stats
                  </div>
                </div>
                <div className="flex justify-start" data-id="element-303">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-304">
                    <p className="flex items-start gap-2" data-id="element-305">
                      <span className="text-xl flex-shrink-0" data-id="element-306">📊</span>
                      <span className="font-medium" data-id="element-307">
                        Your ScribeTok Creator Stats
                      </span>
                    </p>
                    <div className="mt-2 ml-7 space-y-1" data-id="element-308">
                      <p data-id="element-309">🎥 23 videos transcribed</p>
                      <p data-id="element-310">💳 15 credits (0 free remaining)</p>
                      <p data-id="element-311">🎁 4 friends referred (+20 bonus credits)</p>
                      <p data-id="element-312">🔗 Linked: @switmer777</p>
                      <p data-id="element-313">📅 Member since: May 15, 2025</p>
                      <p className="mt-2" data-id="element-314">
                        🏆 Most popular: "How I built my startup" (1.2M views)
                      </p>
                    </div>
                    <p className="text-xs mt-3 text-primary font-medium ml-7" data-id="element-315">
                      Text /myvideos to see your top content!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Benefits Section */}
        <div className="mb-16" data-id="element-316">
          <h2 className="text-2xl font-bold mb-8" data-id="element-317">Creator Benefits</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-318">
            <div className="flex flex-col items-center text-center p-4" data-id="element-319">
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-320">
                <TrendingUp size={24} className="text-primary" data-id="element-321" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-322">Track Performance</h3>
              <p className="text-sm text-muted-foreground" data-id="element-323">
                Monitor views, likes, and engagement across all your TikTok
                content
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-324">
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-325">
                <Star size={24} className="text-primary" data-id="element-326" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-327">Identify Top Content</h3>
              <p className="text-sm text-muted-foreground" data-id="element-328">
                See which videos perform best and understand what resonates with
                your audience
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-329">
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-330">
                <Zap size={24} className="text-primary" data-id="element-331" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-332">
                Special Creator Perks
              </h3>
              <p className="text-sm text-muted-foreground" data-id="element-333">
                Get extra features when transcribing your own content
              </p>
            </div>
          </div>
        </div>
        {/* My Videos Example */}
        <div className="mb-16" data-id="element-334">
          <h2 className="text-2xl font-bold mb-6" data-id="element-335">Your Top Content</h2>
          <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left max-w-xl mx-auto" data-id="element-336">
            <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-337">
              <Video size={18} className="text-primary mr-2" data-id="element-338" />
              Top Videos Command
            </h3>
            <div className="space-y-4" data-id="element-339">
              <div className="flex justify-end" data-id="element-340">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-341">
                  /myvideos
                </div>
              </div>
              <div className="flex justify-start" data-id="element-342">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-343">
                  <p className="flex items-start gap-2" data-id="element-344">
                    <span className="text-xl flex-shrink-0" data-id="element-345">📱</span>
                    <span className="font-medium" data-id="element-346">
                      Your Top TikTok Videos (@switmer777)
                    </span>
                  </p>
                  <div className="mt-2 ml-7 space-y-3" data-id="element-347">
                    <div data-id="element-348">
                      <p className="font-medium" data-id="element-349">
                        1. "How I built my startup in 30 days"
                      </p>
                      <p className="text-sm text-gray-300" data-id="element-350">
                        1.2M views, 89K likes
                      </p>
                    </div>
                    <div data-id="element-351">
                      <p className="font-medium" data-id="element-352">
                        2. "Morning routine that changed my life"
                      </p>
                      <p className="text-sm text-gray-300" data-id="element-353">
                        450K views, 34K likes
                      </p>
                    </div>
                  </div>
                  <p className="text-xs mt-3 text-primary font-medium ml-7" data-id="element-354">
                    Keep creating! Text /stats for your full dashboard.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Technical Features */}
        <div className="mb-16" data-id="element-355">
          <h2 className="text-2xl font-bold mb-8" data-id="element-356">Smart Technical Features</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-357">
            <div className="bg-secondary/30 p-4 rounded-lg flex items-start gap-3" data-id="element-358">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-359">
                <LinkIcon size={16} className="text-primary" data-id="element-360" />
              </div>
              <div data-id="element-361">
                <p className="font-medium" data-id="element-362">Smart URL Parsing</p>
                <p className="text-sm text-muted-foreground" data-id="element-363">
                  Handles @handle OR full TikTok URLs
                </p>
              </div>
            </div>
            <div className="bg-secondary/30 p-4 rounded-lg flex items-start gap-3" data-id="element-364">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-365">
                <User size={16} className="text-primary" data-id="element-366" />
              </div>
              <div data-id="element-367">
                <p className="font-medium" data-id="element-368">Creator Detection</p>
                <p className="text-sm text-muted-foreground" data-id="element-369">
                  Automatically identifies your own videos
                </p>
              </div>
            </div>
            <div className="bg-secondary/30 p-4 rounded-lg flex items-start gap-3" data-id="element-370">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-371">
                <BarChart3 size={16} className="text-primary" data-id="element-372" />
              </div>
              <div data-id="element-373">
                <p className="font-medium" data-id="element-374">Rich Stats Tracking</p>
                <p className="text-sm text-muted-foreground" data-id="element-375">
                  Views, likes, top creators, referrals
                </p>
              </div>
            </div>
            <div className="bg-secondary/30 p-4 rounded-lg flex items-start gap-3" data-id="element-376">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-377">
                <Smartphone size={16} className="text-primary" data-id="element-378" />
              </div>
              <div data-id="element-379">
                <p className="font-medium" data-id="element-380">SMS Optimized</p>
                <p className="text-sm text-muted-foreground" data-id="element-381">
                  Concise, scannable format for mobile
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Section */}
        <div className="mb-16 bg-primary/5 rounded-xl p-8 border border-primary/20" data-id="element-382">
          <h2 className="text-2xl font-bold mb-4" data-id="element-383">
            Ready to Become a Creator?
          </h2>
          <p className="text-lg text-muted-foreground mb-6 max-w-xl mx-auto" data-id="element-384">
            Link your TikTok account now and unlock powerful analytics, track
            your performance, and get special creator perks.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-385">
            <a href={smsHref} data-id="element-386">
              <Button size="lg" className="w-full sm:w-auto" data-id="element-387">
                <MessageSquare size={16} className="mr-2" data-id="element-388" />
                Text Now
              </Button>
            </a>
            <div className="flex items-center gap-2 px-4 py-2 bg-secondary rounded-full cursor-pointer" onClick={handleCopyNumber} data-id="element-389">
              <span className="font-medium" data-id="element-390">{phoneNumber}</span>
              {copied ? <Check size={16} className="text-green-500" data-id="element-391" /> : <Copy size={16} data-id="element-392" />}
            </div>
          </div>
        </div>
        {/* Why This Matters */}
        <div className="mb-16" data-id="element-393">
          <h2 className="text-2xl font-bold mb-8" data-id="element-394">Why This is Game-Changing</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-395">
            <div className="bg-secondary/30 p-5 rounded-lg text-left" data-id="element-396">
              <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-397">
                <User size={18} className="text-primary mr-2" data-id="element-398" />
                For Creators
              </h3>
              <ul className="space-y-2" data-id="element-399">
                <li className="flex items-start gap-2" data-id="element-400">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-401" />
                  <span data-id="element-402">Track performance without logging into TikTok</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-403">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-404" />
                  <span data-id="element-405">Identify your most successful content</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-406">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-407" />
                  <span data-id="element-408">Get special features for your own videos</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-409">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-410" />
                  <span data-id="element-411">Easy sharing of stats with collaborators</span>
                </li>
              </ul>
            </div>
            <div className="bg-secondary/30 p-5 rounded-lg text-left" data-id="element-412">
              <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-413">
                <Share2 size={18} className="text-primary mr-2" data-id="element-414" />
                For Everyone
              </h3>
              <ul className="space-y-2" data-id="element-415">
                <li className="flex items-start gap-2" data-id="element-416">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-417" />
                  <span data-id="element-418">Feel like a TikTok pro with creator identity</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-419">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-420" />
                  <span data-id="element-421">Share stats with friends (natural viral loops)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-422">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-423" />
                  <span data-id="element-424">Earn referral credits by sharing with friends</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-425">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-426" />
                  <span data-id="element-427">Unique SMS analytics no other service offers</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Trust Indicators */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-muted-foreground mb-8" data-id="element-428">
          <div className="flex items-center gap-2" data-id="element-429">
            <CheckCircle size={16} className="text-success" data-id="element-430" />
            <span data-id="element-431">10,000+ Creators Tracked</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-432">
            <CheckCircle size={16} className="text-success" data-id="element-433" />
            <span data-id="element-434">100M+ Views Analyzed</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-435">
            <CheckCircle size={16} className="text-success" data-id="element-436" />
            <span data-id="element-437">Private & Secure</span>
          </div>
        </div>
        {/* Footer CTA */}
        <div className="border-t border-border/50 pt-8" data-id="element-438">
          <p className="text-lg font-medium mb-4" data-id="element-439">Ready to get started?</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-440">
            <a href={smsHref} data-id="element-441">
              <Button size="lg" data-id="element-442">
                <MessageSquare size={16} className="mr-2" data-id="element-443" />
                Text /link to {phoneNumber}
              </Button>
            </a>
            <Link to="/app" data-id="element-444">
              <Button variant="outline" size="lg" data-id="element-445">
                Go to Web App
                <ArrowRight size={16} className="ml-2" data-id="element-446" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}